__turbopack_context__.v({
  "form": "PhoneCodeVerificationInput-module-scss-module__DxE2vG__form",
  "verificationCodeError": "PhoneCodeVerificationInput-module-scss-module__DxE2vG__verificationCodeError",
  "verificationTokenFormContainer": "PhoneCodeVerificationInput-module-scss-module__DxE2vG__verificationTokenFormContainer",
  "verificationTokenFormContainerError": "PhoneCodeVerificationInput-module-scss-module__DxE2vG__verificationTokenFormContainerError",
});
